<div class="mm-profile-page micromate-profile-media">
    <mm-media *ngIf="mediaData !== undefined"
              [autoplay]="true"
              [mediaData]="mediaData"
              [size]="'fullScreen'"></mm-media>
</div>
